module.exports = __webpack_public_path__ + "img/banner-2.3b14a93f.jpg";